import { render, staticRenderFns } from "./EmiTable.vue?vue&type=template&id=5b620110&scoped=true"
import script from "./EmiTable.vue?vue&type=script&lang=js"
export * from "./EmiTable.vue?vue&type=script&lang=js"
import style0 from "./EmiTable.vue?vue&type=style&index=0&id=5b620110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b620110",
  null
  
)

export default component.exports